import styled from 'styled-components';
import SwipeableViews from 'react-swipeable-views';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../locales';
import { trackEvent } from '../../../helpers/common';
import events from '../../../app/events';
import ProgressIndicator from '../../../common/ProgresIndicator';

const Container = styled.div`
  background-color: white;
  border-radius: 5px;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.2);
  overflow: hidden;
`;

const Image = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url('${({ src }) => src}');
  height: 384px;
  width: 100%;
  /* border-radius: 5px 5px 0 0; */
`;

const Title = styled.h3`
  padding: 15px 15px 8px;
`;

const SectionTitle = styled.h2`
  margin-top: 20px;
  margin-bottom: 10px;
`;

const PostItem = styled.div`
  border-radius: 5px;
  background-color: white;
`;

const BlogPosts = ({
  posts
}) => {
  const [error, setError] = useState();
  const [index, setIndex] = useState(0);
  const { push } = useHistory();

  const viewArticle = (id) => {
    trackEvent(events.DZ_HOME_BLOG_ITEM_TAP, { blog_id: id });
    push(`/blog-article/${id}`);
  };

  return (
    <div style={{ marginBottom: 50 }}>
      <SectionTitle>{__('app.blog')}</SectionTitle>
      <Container>
        <SwipeableViews
          index={index}
          onChangeIndex={(i) => {
            trackEvent(events.DZ_HOME_BLOG_ITEMS_SWIPE);
            setIndex(i);
          }}
        >
          {
            posts
            && Object.keys(posts)
              .map((key) => posts[key])
              .sort((a, b) => a.index - b.index) // sort by the index property
              .map(({ id, image, title }) => (
                <PostItem
                  onClick={() => viewArticle(id)}
                  key={id}
                >
                  {error || null}
                  <Image onError={() => setError('something went wrong')} src={image} alt="blog image" />
                  <Title>{title}</Title>
                </PostItem>
              ))
          }
        </SwipeableViews>
        <ProgressIndicator
          data={posts}
          index={index}
          setIndex={setIndex}
          accessibilityLabel="Blog post"
        />
      </Container>
    </div>
  );
};

export default BlogPosts;
